import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Divider,
    Grid,
    Typography
} from '@mui/material';
import { CaretExpanded } from '@tassat/icon';
import { formatAsCurrency, formatEpochDate } from '@tassat/utility';
import * as React from 'react';

import muiStyles from './styles';
import { AccountBalancesCurrencyTileProps } from './types';

export function AccountBalancesCurrencyTile(props: AccountBalancesCurrencyTileProps) {
    const {
        currency,
        accountCurrencyStatistics,
        expandedItems,
        allowControlledInput = false,
        onChange,
        navPrice,
        showPrice = false
    } = props;

    const classes = muiStyles(props);

    return (
        <Grid
            container
            direction='column'
            spacing={0}
            wrap='nowrap'
        >
            <Accordion
                className={classes.accordionContainer}
                expanded={allowControlledInput ? expandedItems?.includes(currency.AlphabeticCode) : undefined}
                onChange={(allowControlledInput && onChange) ? onChange(currency.AlphabeticCode) : undefined}
            >
                <AccordionSummary
                    className={classes.accordionSummary}
                    expandIcon={<CaretExpanded />}
                >
                    <Grid
                        // alignItems='center'
                        container
                        direction='column'
                        spacing={0}
                        wrap='nowrap'
                    >
                        <Grid
                            alignItems='center'
                            container
                            direction='row'
                            spacing={0}
                            wrap='nowrap'
                        >
                            <Grid item>
                                <Typography className={classes.currencyCode}>{currency.AlphabeticCode}</Typography>
                            </Grid>
                            {
                                accountCurrencyStatistics.headerPrimaryStats.map((headerStats, i) => (

                                    <React.Fragment key={`header-stat-${i}`}>
                                        <Divider
                                            className={classes.verticalDivider}
                                            orientation='vertical'
                                        />
                                        <Grid
                                            container
                                            direction='column'
                                            item
                                        >
                                            <Typography className={classes.summaryHeader}>{headerStats.title}</Typography>
                                            <Typography className={classes.summaryContent}>{headerStats.statistic}</Typography>
                                        </Grid>
                                    </React.Fragment>

                                ))
                            }
                        </Grid>
                        {showPrice &&
                            <Grid item>
                                <Typography className={classes.navPrice}>NAV at {formatAsCurrency(navPrice?.Price)} as of {`${formatEpochDate(navPrice?.AuditTime, 'MMM DD YYYY')} at ${formatEpochDate(navPrice?.AuditTime, 'HH:mm:ss')} ET`}</Typography>
                            </Grid>}
                    </Grid>
                </AccordionSummary>
                <AccordionDetails className={classes.detailsContainer}>
                    <Grid
                        container
                        direction='column'
                        spacing={0}
                        wrap='wrap'
                    >
                        <Divider className={classes.divider} />
                        <Grid
                            className={classes.details}
                            container
                            direction='row'
                            item
                            justifyContent='space-between'
                            spacing={0}
                            wrap='wrap'
                        >
                            {
                                accountCurrencyStatistics.detailStats.map((stats, i) => (
                                    <Grid
                                        alignItems='flex-end'
                                        className={classes.detailsBox}
                                        container
                                        direction='row'
                                        item
                                        key={`detail-stat-${i}`}
                                        wrap='nowrap'
                                    >
                                        <Typography className={`${classes.detailsTitle} ${classes.title}`}>{stats.title}:</Typography>
                                        <Typography
                                            className={classes.detailsValue}
                                            component='div'
                                        >
                                            {stats.statistic}{stats.equivalentValue !== undefined ? <Divider /> : ''}
                                            {stats.equivalentValue !== undefined ?
                                                <Typography className={classes.detailsEquivalent}>
                                                    {stats.equivalentValue}
                                                </Typography> : ''}
                                        </Typography>
                                        <Typography className={`${classes.detailsTitle} ${classes.transactionTitle}`}>Transactions:</Typography>
                                        <Typography
                                            className={`${classes.transactionsBox} ${classes.bgLightBlue}`}
                                        >
                                            {stats.statisticCount}
                                        </Typography>
                                    </Grid>
                                ))
                            }
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>
        </Grid>
    );
}